'use client'

import Calculator, { type CalculatorFormData } from '@/app/Calculator'

type SeparationCalculatorProps = {
  initialValues?: Partial<CalculatorFormData>
}

export default function SeparationCalculator({ initialValues }: SeparationCalculatorProps) {
  return <Calculator mode="separation" initialValues={initialValues} />
}
